<template>
  <single-panel-page with-wrapper title="Logged out">
    <div class="mt-8">
      <p class="text-[#22c55e] font-semibold text-center text-base">
        You were successfully logged out.
      </p>

      <a
        :href="getNewAppUrl($router.resolve({ name: 'login' }).href)"
        class="hover:no-underline inline-flex items-center px-5 py-1.5 border-2 font-bold rounded-lg focus:outline-none transition-colors duration-150 border-yellow-500 bg-yellow-300 hover:bg-yellow-400 hover:text-[#D99627] text-[#D99627] hover:border-yellow-600 w-full justify-center mt-1 text-base"
      >
        Click here to log back in
      </a>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import { getNewAppUrl } from '@/utils/urls'

export default {
  mounted() {
    Auth.logout()
    this.$store.dispatch('user/logout')
  },
  setup() {
    return { getNewAppUrl }
  },
}
</script>
